import styled from 'styled-components';
import { Text } from '@lux/text';

export const Container = styled.div`
    display: flex;
    margin: 0;
`;

export const SpecialText = styled(Text)`
    justify-content: center;
    align-self: flex-end;
    padding-left: 10px;
`;

export const RegularContainer = styled.span`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: right;
    text-transform: lowercase;
`;

export const RegularText = styled(Text)`
    padding-left: 10px;
`;

export const MaxDiscountText = styled(Text)`
    text-align: right;
`;
